import map from "Assets/images/commitment-map.svg";
import arrowBtn from "Assets/icons/arrow_left.svg";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CityLabel from "./CityLabel";
import useIsMobile from "Hooks/useIsMobile";
import BuenosAires from "./BuenosAires";
import { trackEvent } from "Services/Analytics/trackEvent";

type LabelCity = {
  province: string;
  cities: string[];
  color: string;
};

const labelCities: LabelCity[] = [
  { province: "Neuquén", cities: ["Neuquén"], color: "#27AA6F" },
  { province: "San Luis", cities: ["Villa Mercedes"], color: "#30B9C9" },
  {
    province: "Rio Negro",
    cities: [
      "Allén",
      "Catriel",
      "Choele-choel",
      "Conesa",
      "Coronel Belisle",
      "Rio Colorado",
      "San Antonio",
    ],
    color: "#106556",
  },
  { province: "Santa Fé", cities: ["San Lorenzo"], color: "#01BE9E" },
  { province: "Córdoba", cities: ["Chajan"], color: "#89CD69" },
  {
    province: "La Pampa",
    cities: ["Estación Gaviotas", "La Adela"],
    color: "#289E5A",
  },
];

const Commitment = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const seeMoreProjects = () => {
    trackEvent("proyectos_button");
    navigate("/projects");
  };
  return (
    <>
      <section
        className="section landing-section relative-section commitment"
        id="commitment"
      >
        <div className="map-container">
          <div className="cityLabel-container">
            {labelCities.map((item, index) => (
              <CityLabel
                key={index}
                province={item.province}
                cities={item.cities}
                color={item.color}
              />
            ))}
          </div>
          <div className="commitment-map-container">
            <img
              width={1920}
              height={1080}
              className="commitment-map"
              src={map}
              alt="mapa de compromiso"
            />
          </div>
        </div>
        <div className="content" style={{ justifyContent: "space-between" }}>
          <div>
            <h2 className="title">{t("commitment.title")}</h2>
            <p className="description">
              {t("commitment.text1")}{" "}
              <mark className="mark-sky">{t("commitment.mark")}</mark>
              {t("commitment.text2")}
            </p>
            <button
              onClick={seeMoreProjects}
              className="button"
              aria-label={t("commitment.button")}
              style={{ marginTop: "2rem" }}
            >
              <img src={arrowBtn} width={24} height={4} alt="arrow rigth" />
              {t("commitment.button")}
            </button>
          </div>
          {!isMobile && <BuenosAires />}
        </div>
      </section>
      {isMobile && <BuenosAires />}
    </>
  );
};

export default Commitment;
